import { defineMessages } from "react-intl";

export const timePeriodTextWithSelectFieldMessages = defineMessages({
  yearLabel: {
    id: "Qe4XHv",
    defaultMessage: "years after issue",
    description: "years after label",
  },
  monthLabel: {
    id: "54KYgS",
    defaultMessage: "months after issue",
    description: "months after label",
  },
  weekLabel: {
    id: "15fg+o",
    defaultMessage: "weeks after issue",
    description: "weeks after label",
  },
  dayLabel: {
    id: "mzASqs",
    defaultMessage: "days after issue",
    description: "days after label",
  },
});
